import { apiGateway } from "@contexts";
import { useQuery } from "@tanstack/react-query";

export interface ClinicalHistoryPatient {
  patientId: number;
  patientUuid: string;
  code?: string;
  documentNumber: string;
  name: string;
  firstSurname: string;
  secondSurname?: string;
  lastEncounter: string;
}

interface ClinicalHistoryPatientsResponse {
  patients: ClinicalHistoryPatient[];
}

export const useDoctorPatients = (doctorCode: string) => {
  return useQuery({
    queryKey: ["doctorPatients", doctorCode],
    queryFn: async () => {
      const response = await apiGateway<ClinicalHistoryPatientsResponse>({
        url: `/clinical-history/doctor/${doctorCode}/patients`,
      });

      return response.patients;
    },
  });
};
